import React from 'react'
import PropTypes from 'prop-types'

const EventTypeIcon = (props) => {
  const { width = 20, height = 20, fill = '#183560' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        minHeight: '20px',
        minWidth: '20px',
      }}
    >
      <g clipPath="url(#clip0_2176_2288)">
        <path
          d="M17.75 3.625C17.75 3.2769 17.6117 2.94306 17.3656 2.69692C17.1194 2.45078 16.7856 2.3125 16.4375 2.3125H13.8125V1H12.5V2.3125H7.25V1H5.9375V2.3125H3.3125C2.9644 2.3125 2.63056 2.45078 2.38442 2.69692C2.13828 2.94306 2 3.2769 2 3.625V16.75C2 17.0981 2.13828 17.4319 2.38442 17.6781C2.63056 17.9242 2.9644 18.0625 3.3125 18.0625H17.8299L17.3656 16.75H3.3125V3.625H5.9375V4.9375H7.25V3.625H12.5V4.9375H13.8125V3.625H16.4375L16.6538 17.9559L17.8299 18.0625L17.75 3.625Z"
          fill={fill}
        />
        <path
          d="M12.375 7.34375C12.375 7.1697 12.4441 7.00278 12.5672 6.87971C12.6903 6.75664 12.8572 6.6875 13.0312 6.6875H14.3438C14.5178 6.6875 14.6847 6.75664 14.8078 6.87971C14.9309 7.00278 15 7.1697 15 7.34375V8.65625C15 8.8303 14.9309 8.99722 14.8078 9.12029C14.6847 9.24336 14.5178 9.3125 14.3438 9.3125H13.0312C12.8572 9.3125 12.6903 9.24336 12.5672 9.12029C12.4441 8.99722 12.375 8.8303 12.375 8.65625V7.34375Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2176_2288">
          <rect width="20" height="20" fill="none" />
        </clipPath>
      </defs>
    </svg>
  )
}

EventTypeIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}
export default EventTypeIcon
